<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-yonghuguanli-fil`]" width="1em" height="1em" v-bind="$attrs"><g :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" fill-rule="evenodd"><path d="M89.9843383,112 C86.6766672,112 83.9693816,109.293305 83.9693816,105.986043 C83.9693816,86.1426465 67.8491987,70.026504 47.9996476,70.026504 C28.1499201,70.026504 12.0299135,86.1426465 12.0299135,105.986043 C12.0299135,109.293305 9.32315656,112 6.01495677,112 C2.70658076,112 0,109.293305 0,105.986043 C0,79.527946 21.5340492,58 47.9996476,58 C74.4657745,58 96,79.527946 96,105.986043 C96,109.353908 93.2925381,112 89.9843383,112 Z" transform="translate(17 8)"/><path d="M47.9695955,68 C29.2048976,68 14,52.7342754 14,34.0300506 C14,15.2648408 29.2649995,0 47.9695955,0 C66.7348237,0 82,15.2648408 82,34.0300506 C81.9398981,52.7342754 66.7348237,68 47.9695955,68 Z M47.9695955,12.067276 C35.902194,12.067276 26.0672247,21.9019663 26.0672247,34.0300506 C26.0672247,46.1579582 35.902194,55.9320169 47.9695955,55.9320169 C60.0375273,55.9320169 69.9325985,46.0971499 69.9325985,34.0300506 C69.9325985,21.9627746 60.0375273,12.067276 47.9695955,12.067276 Z" transform="translate(17 8)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmYonghuguanliFil',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
